module.exports = __webpack_public_path__ + "static/media/gardenPlants.0d6e277a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gardenPlants.jpg
// module id = 169
// module chunks = 0